import {
   Gantt,
   Fullscreen,
   Willow,
   Toolbar,
   Editor,
   ContextMenu,
   defaultEditorItems,
   defaultToolbarButtons
} from "@svar-ui/react-gantt"; //import theme and component
import { Locale } from "@svar-ui/react-core";
import AxiosInstance from 'src/components/Axios'
import { useEffect, useRef, useState } from "react";
import { CFormInput, CFormLabel } from '@coreui/react';
import "@svar-ui/react-gantt/all.css";
import uk from "src/components/store/granttLocale";
import { useLoaderData, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import CreateWorkSchedule from "src/components/work_plan/CreateWorkSchedule";
import { toast } from 'react-toastify';
import axios from 'axios';

// Дістаємо з відповіді API причину помилки імпорту та пояснення
const getImportError = (err) => {
   const data = err?.response?.data;
   if (!data) {
      return { title: 'Помилка при імпорті файлу', details: 'Сервер не відповідає. Перевірте зʼєднання та спробуйте ще раз.' };
   }
   return {
      title: data.error || data['hydra:title'] || data.title || 'Помилка при імпорті файлу',
      details: data.details || data['hydra:description'] || data.detail || '',
   };
};

const columns = [
   { id: "text", header: "Назва задачі", width: 200, flexgrow: 2 },
   {
      id: "start",
      header: "Дата початку",
      flexgrow: 1,
      width: 150,
      align: "center",
   },
   {
      id: "end",
      header: "Дата завершення",
      flexgrow: 1,
      width: 150,
      align: "center",
   },
   //  {
   //    id: "duration",
   //    header: "Тривалість",
   //    align: "center",
   //    width: 150,
   //    flexgrow: 1,
   //  },
   //  {
   //    id: "workers",
   //    header: "Працівники",
   //    width: 100,
   //    align: "center",
   //  },
];

// Параметри - якщо треба стрілка звязок
// id- (необов'язково) ідентифікатор посилання
// source- (обов'язково) ідентифікатор вихідного завдання
// target- (обов'язково) ідентифікатор цільового завдання
// type- (обов'язково) тип посилання; можливі значення типу посилання:
// e2s - "Від початку до кінця"
// s2s - "Від початку до початку"
// e2e - "Від кінця до кінця"
// s2e - "Від початку до кінця"
// const links = [{ id: 1, source: 1, target: 2, type: "e2e" }];

const scales = [
   { unit: "month", step: 1, format: "MMMM yyy" },
   { unit: "day", step: 1, format: "d" }
];

// хто увійшов
const role = localStorage.getItem('user_role');
// дані користувача
const user_data = localStorage.getItem('user_data');
const tokenStr = localStorage.getItem('user');

const urlApi = '/work_graphs'
const readonly = true; // параметр для відображення/приховування меню реаугвання графіків

export async function LoaderWorkSchedulesUpdate({ params }) {
   console.log('loader')
   const id = params.pid
   if (Object.keys(params).length !== 0) {
      try {
         //запит за графіками
         const response = await AxiosInstance.get(`${urlApi}/${id}`)
         //запит за stages
         const stagesResponse = await AxiosInstance.get(`/work_graph_stages?workGraph.id=${id}&pagination=false`);
         const stages = stagesResponse.data?.['hydra:member'] || [];

         return { data: response.data, stages }
      } catch (error) {
         console.error('Помилка під час виконання запитів', error)
         return null
      }
   }
   return null
}

export default function WorkScheduleNew() {

   // дані для оновлення
   const { data, stages } = useLoaderData() || {}
   const [api, setApi] = useState(null);
   const [tasks, setTasks] = useState([]);
   const [graficLoad, setGraficLoad] = useState(false);
   const navigate = useNavigate();

   const [userId, setUserId] = useState(false)
   //для вибору файлу з графіком
   const [file, setFile] = useState(null);
   //для вибору партнера
   const [selectedOptionPartner, setSelectedOptionPartner] = useState('');
   //для вибору factory
   const [selectedOptionFactories, setSelectedOptionFactories] = useState('');
   //для вибору договору
   const [selectedAgreement, setSelectedAgreement] = useState('');
   const [agreementsOptions, setAgreementsOptions] = useState([])
   //інженери
   const [engineers, setEngineers] = useState([])
   //для вибору інженера
   const [selectedOptionEngineers, setSelectedOptionEngineers] = useState('')
   //для внесення опису 
   const [description, setDescription] = useState(data !== undefined ? data.description : '');

   //список статичних типів
   const [localTypeStages, setLocalTypeStages] = useState([])
   const apiRef = useRef(null);
   const fileInputRef = useRef(null);

   useEffect(() => {
      AxiosInstance.get(`/work_types_lists?pagination=false`).then(response => {
         setLocalTypeStages(response.data?.['hydra:member']?.map((result) => ({
            label: result.name,
            value: result.id,
         })) || []
         )
      })
   }, [])

   useEffect(() => {
      // const stages = data?.workGraphStages;
      console.log('render')
      if (stages?.length > 0 && localTypeStages.length > 0) {
         const workSummary = stages.map((stage) => {
            const children = stage?.workGraphTypes ?? []
            // 1.зміна .Коментуєм потрібна перевірка на пусті дати в типах
            //робимо перевірку на пусту дату в типах і пропускаєм тип якщо дати нема
            // const startDate = children?.reduce((acc, t) => dayjs(t.dateStart).isBefore(acc) ? dayjs(t.dateStart) : acc, dayjs(children[0].dateStart)).toDate();
            // const endDate = children?.reduce((acc, t) => dayjs(t.dateEnd).isAfter(acc) ? dayjs(t.dateEnd) : acc, dayjs(children[0].dateEnd)).toDate();
            const validChildren = children.filter(t =>
               t.dateStart && t.dateEnd &&
               dayjs(t.dateStart).isValid() && dayjs(t.dateEnd).isValid()
            )
            if (validChildren.length === 0) return null
            const startDate = validChildren.reduce((acc, t) => dayjs(t.dateStart).isBefore(acc) ? dayjs(t.dateStart) : acc, dayjs(validChildren[0].dateStart)).toDate();
            const endDate = validChildren.reduce((acc, t) => dayjs(t.dateEnd).isAfter(acc) ? dayjs(t.dateEnd) : acc, dayjs(validChildren[0].dateEnd)).toDate();
            //1.зміна(кінець)

            return {
               id: stage.id,
               text: stage?.workStagesList?.name || '',
               start: startDate,
               end: endDate,
               duration: Math.max(dayjs(endDate).diff(dayjs(startDate), 'day'), 1),
               progress: 0,
               parent: 0,
               type: "summary",
               open: true,
            }
         })
            //2. зміна .Додаєм filter(Boolean)
            .filter(Boolean)
         //2.зміна(кінець)
         console.log('workSummary', workSummary)
         const workTasks = stages.flatMap((stage) => {
            const children = stage?.workGraphTypes ?? []
            return children
               //3.зміна -потрібно фільтрувати типи без дат
               .filter(type =>
                  type.dateStart && type.dateEnd &&
                  dayjs(type.dateStart).isValid() && dayjs(type.dateEnd).isValid()
               )
               //3.зміна (кінець)
               .map((type) => {
                  // console.log('type', type)
                  // console.log('getIdFromIri', getIdFromIri(type?.workTypeList))
                  // console.log('find', localTypeStages.find(elem => elem.value == getIdFromIri(type?.workTypeList))?.label || '')
                  return {
                     id: `task-${type.id}`,
                     // text: type?.workTypeList?.name || '',
                     //оновлене поле
                     text: localTypeStages.find(elem => elem.value == getIdFromIri(type?.workTypeList))?.label || '',
                     start: new Date(type.dateStart),
                     end: new Date(type.dateEnd),
                     duration: Math.max(dayjs(type.dateEnd).diff(dayjs(type.dateStart), 'day'), 1),
                     progress: 0,
                     parent: stage.id,
                     type: "task",
                  }
               })
         })

         // console.log('workTasks', workTasks)
         // console.log('localTypeStages', localTypeStages)
         const allTasks = [...workSummary, ...workTasks]
         setTasks(allTasks)
      }
   }, [
      // data
      stages, localTypeStages
   ])


   const options = [
      {
         id: "add-task",
         text: "Додати",
         icon: "wxi-plus",
         data: [{ id: "add-task:child", text: "Дочірнє завдання" }],
      },
      { type: "separator" },
      {
         id: "edit-task",
         text: "Редагувати",
         icon: "wxi-edit",
      },
      { id: "cut-task", text: "Вирізати", icon: "wxi-content-cut" },
      { id: "copy-task", text: "Копіювати", icon: "wxi-content-copy" },
      { id: "paste-task", text: "Вставити", icon: "wxi-content-paste" },
      { id: "delete-task", text: "Видалити", icon: "wxi-delete" },
   ];


   const bottomBar = {
      items: [
         { comp: "button", type: "secondary", text: "Закрити", id: "close" },
         { comp: "spacer" },
         { comp: "button", type: "danger", text: "Видалити", id: "delete" },
         { comp: "button", type: "primary", text: "Зберегти", id: "save" },
      ],
   };

   const itemsTool = defaultToolbarButtons.map((b) => {
      return { ...b, text: (b.id === 'add-task' ? 'Додати етап' : b.text) }
   });

   const newEditorElements = [...defaultEditorItems, {
      "key": "workers",
      "comp": "counter",
      "label": "Працівники",
      "config": {
         "min": 1
      }
   }]

   //Функція отримання айді з ірі
   function getIdFromIri(iri) {
      if (!iri) return null;
      return iri.split('/').pop();
   }

   // Функція для зміни факторі
   const handleChangeFactories = (select) => {
      //обнулююм інженера
      setSelectedOptionEngineers('')

      setSelectedOptionFactories(select)
   }
   const handleChangeAgreement = (select) => {
      setSelectedAgreement(select)
   }
   // при зміні опції підрядника
   const handleChangePartner = (select) => {
      setSelectedOptionPartner(select)
      setSelectedAgreement('')
   }

   //Функція для зміни інженера
   const handleChangeEngineers = (select) => {
      console.log(select, 'select')
      setSelectedOptionEngineers(select)
   }

   // при зміні обраного файлу
   const handleFileChange = (event) => {
      const myFile = event.target.files[0]
      setFile(myFile)
   }

   // завантаження опцій підрядників у форму
   const loadOptionsPartners = async (inputValue) => {
      console.log('request')
      if (role === 'ROLE_ADMIN') {
         const accounts = await AxiosInstance.get(`/accounts?name=${inputValue}`
         ).then((response) => {
            return response.data?.['hydra:member'].map((result) => ({
               label: result.name,
               value: result.id,
            }))
         }).catch(e => console.log(e))
         return accounts
      } else {

         if (userId !== false) {
            return await AxiosInstance.get(`/accounts?user.id=${userId}`
            ).then((response) => {
               return response.data?.['hydra:member'].map((result) => ({
                  label: result.name,
                  value: result.id,
               }))
            })
         }
      }
   }

   // Завантажити список факторіс
   const loadOptionsFactory = async (inputValue) => {
      return await AxiosInstance.get(`/factories?name=${inputValue}`
      ).then((response) => {
         return response.data?.['hydra:member'].map((result) => ({
            label: result.name,
            value: result.id,
         }))
      })
   }

   //  завантаження опцій договорів для селекту залежно від вибраного акаунту заводу
   const loadOptionsAgreements = async (selectedAccount) => {
      return await AxiosInstance.get(`/agreements?account.id=${selectedAccount.value}`
      ).then((response) => {
         const agreements = response.data?.['hydra:member'].map((result) => ({
            label: result.name,
            value: result.id,
         }))
         setAgreementsOptions(agreements);
         return agreements
      })
   }
   //завантажити список інженерів
   const loadOptionsEngineers = async (selectedFactory) => {

      return await AxiosInstance.get(`/factories?name=${selectedFactory.label}`
         // , header
      ).then((response) => {
         console.log('res1', response);
         const engineers = response.data
            ?.['hydra:member'][0]
            .engineers
            .map((result) => ({
               label: result.name,
               value: result.id,
            }))
         // console.log('res2', engineersOptions);
         // console.log('selectedOptionEngineers before:', selectedOptionEngineers);
         setEngineers(engineers);
         // console.log('selectedOptionEngineers after:', selectedOptionEngineers);
         return engineers
      })
   }



   // Викликати ф-цію запиту за списком для отримання списку договорів
   useEffect(() => {

      if (selectedOptionPartner !== '') {
         loadOptionsAgreements(selectedOptionPartner);
      }
   }, [selectedOptionPartner]);

   //викликати ф-цію для отримання інженерів по підрозділу
   useEffect(() => {
      // console.log('selectedOptionPartner', selectedOptionPartner);
      if (selectedOptionFactories !== '') {
         loadOptionsEngineers(selectedOptionFactories);
      }

   }, [selectedOptionFactories]);

   // Заповнити Id користувача
   useEffect(() => {
      if (user_data != null) {
         let data = JSON.parse(user_data)
         setUserId(data.id)
      }
   }, [user_data])

   const clearData = () => {
      setSelectedOptionPartner('');
      setSelectedOptionFactories('');
      setSelectedAgreement('');
      setDescription('');
      setSelectedOptionEngineers('')
      setEngineers([]);
      setFile(null);


      // очистка візуально input type="file"
      if (fileInputRef.current) {
         fileInputRef.current.value = null;
      }

      setGraficLoad(false);
   }

   // Функція для відправки даних
   const handleSubmit = async (event) => {
      event.preventDefault();
      try {
         if (selectedOptionPartner.value !== undefined && selectedAgreement.value !== undefined && selectedOptionFactories.value !== undefined && file !== null) {
            setGraficLoad(true);
            const data_response = {
               account: `/api/accounts/${selectedOptionPartner.value}`,
               description: description,
               dateEntered: dayjs().toISOString(),
               agreement: `/api/agreements/${selectedAgreement.value}`,
               factory: `/api/factories/${selectedOptionFactories.value}`,
               engineer: `/api/engineers/${selectedOptionEngineers.value}`,
               status: 'new',
            };

            // спочатку створюєм сам графік без даних 
            AxiosInstance.post(`${urlApi}`, data_response).then((response) => {
               const workGraf = response.data;
               // імпортуєм файл з графіком в апі медіа
               const config = {
                  headers: {
                     'Content-Type': 'multipart/form-data',
                     "Authorization": `Bearer ${tokenStr}`
                  },
               };
               const formData = new FormData();
               formData.append('file', file);
               formData.append('fileName', file.name);
               // імпортуєм файл з графіком в апі медіа
               axios.post(process.env.REACT_APP_SERVER_URL + '/api/media_objects', formData, config).then(async (response) => {
                  const mediaId = response.data.id;
                  const mediaIri = response.data['@id']

                  //додатковий блок для привязки файлу до графіка
                  try {
                     await AxiosInstance.patch(
                        `/work_graphs/${workGraf.id}`,
                        {
                           mediaFile: mediaIri
                        },
                     );
                  } catch (err) {
                     toast.error('Помилка привʼязки файлу до графіку');

                     try {
                        await AxiosInstance.delete(`/work_graphs/${workGraf.id}`);
                     } catch (e) {
                        console.error('Не вдалося видалити графік після помилки PATCH', e);
                     }

                     clearData();
                     return;
                  }
                  //додатковий блок для привязки файлу до графіка
                  const importData = {
                     "media_id": mediaId,
                     "work_graph_id": workGraf.id
                  }
                  // імпортуєм файл з графіком в апі імпорту де графік має розпаристись
                  AxiosInstance.post('/work_graphs/import_excel', importData).then((response) => {
                     setGraficLoad(false);
                     if (response.status === 201) {
                        toast.success('Графік успішно створено');
                        clearData();
                        navigate(urlApi + '/view/' + workGraf.id);
                     }
                  }).catch(async (err) => {
                     const { title, details } = getImportError(err);
                     toast.error(
                        <div>
                           <strong>{title}</strong>
                           {details && <div style={{ marginTop: 4 }}>{details}</div>}
                        </div>,
                        { autoClose: 15000 }
                     );
                     clearData();
                     try {
                        await AxiosInstance.delete(`/work_graphs/${workGraf.id}`);
                     } catch (err) {
                        console.error('Помилка при видаленні графіку після невдалого імпорту', err);
                     }

                  })
               }).catch(async () => {
                  toast.error('Помилка при створенні медіа файлу');
                  try {
                     await AxiosInstance.delete(`/work_graphs/${workGraf.id}`);
                  } catch (err) {
                     console.error('Помилка при видаленні графіку після помилки медіа', err);
                  }
                  clearData();
               })
            }).catch(() => {
               toast.error('Помилка при створені графіку');
               clearData();
            })
         }
         else {
            toast.error('Заповніть форму!');
         }
      } catch (e) {
         toast.error('Сталася помилка при збереженні');
         console.error(e);
      }
   }

   // console.log('data', data)
   // console.log('stages', stages)
   // console.log('selectedOptionEngineers', selectedOptionEngineers)
   // console.log('selectedOptionsAgreenment', selectedAgreement)
   // console.log('file', file)
   // console.log('selectedOpto=ionPartner', selectedOptionPartner)
   // console.log('selectedOptionFactories', selectedOptionFactories)
   return (
      <div className="work-schedule-container">
         {data ? <>
            <div className="mb-5">
               {/* секція шапки для існуючого плану */}
               <div className="mb-3">
                  <CFormLabel htmlFor="exampleFormControlInput1">Контрагент</CFormLabel>
                  <CFormInput
                     type="text"
                     id="exampleFormControlInput1"
                     value={data?.account?.name || ""}
                     disabled
                     autoComplete="off"
                  />
               </div>
               <div className="mb-3">
                  <CFormLabel htmlFor="exampleFormControlInput3">Підрозділ</CFormLabel>
                  <CFormInput
                     type="text"
                     id="exampleFormControlInput3"
                     value={data?.factory?.name || ""}
                     disabled
                     autoComplete="off"
                  />
               </div>
               {/* інпут для інженера */}
               <div className="mb-3">
                  <CFormLabel htmlFor="exampleFormControlInput3">Інженер</CFormLabel>
                  <CFormInput
                     type="text"
                     id="exampleFormControlInput3"
                     value={data?.engineer?.name || ""}
                     disabled
                     autoComplete="off"
                  />
               </div>
               {/* інпут для інженера */}

               <div className="mb-3">
                  <CFormLabel htmlFor="exampleFormControlInput4">Статус</CFormLabel>
                  <CFormInput
                     type="text"
                     id="exampleFormControlInput4"
                     value={data?.status || ""}
                     disabled
                     autoComplete="off"
                  />
               </div>

               <div className="mb-3">
                  <CFormLabel htmlFor="exampleFormControlInput2">Опис</CFormLabel>
                  <CFormInput
                     type="text"
                     id="exampleFormControlInput2"
                     value={data?.description || ""}
                     disabled
                     autoComplete="off"
                  />
               </div>
               {/* Блок для медіа файлу */}
               <div className="mb-3">
                  <CFormLabel>Переглянути файл графіка</CFormLabel>
                  {data?.mediaFile ? (
                     <div>
                        <a
                           href={process.env.REACT_APP_SERVER_URL + data.mediaFile?.contentUrl}
                           target="_blank"
                           rel="noopener noreferrer"
                        >
                           Відкрити файл
                        </a>
                     </div>
                  ) : (
                     <div>Файл не прикріплено</div>
                  )}
               </div>
            </div>

            <div style={!readonly ? { height: '700px' } : { height: '670px' }}>
               <Locale words={uk} >
                  <Fullscreen >
                     <Willow>
                        {!readonly ?
                           <>
                              <ContextMenu api={api} options={options}>
                                 <Toolbar api={api} items={itemsTool} />
                                 <Gantt
                                    init={setApi}
                                    // init={(ganttApi) => {
                                    //    if (!apiRef.current) {
                                    //       apiRef.current = ganttApi;
                                    //       setApi(ganttApi);
                                    //    }
                                    // }}

                                    tasks={tasks}
                                    // links={links} 
                                    scales={scales}
                                    columns={columns}
                                    zoom={true}
                                    readonly={readonly}
                                 />
                                 {api && <Editor api={api} items={newEditorElements} bottomBar={bottomBar} topBar={false} placement="modal" />}
                              </ContextMenu>
                           </>
                           : <>
                              <Gantt
                                 tasks={tasks}
                                 // links={links} 
                                 scales={scales}
                                 columns={columns}
                                 zoom={true}
                                 readonly={true}
                              />
                           </>}
                     </Willow>
                  </Fullscreen >
               </Locale>
            </div>
         </>
            : (userId !== false && <CreateWorkSchedule
               data={data}
               handleSubmit={handleSubmit}
               loadOptionsPartners={loadOptionsPartners}
               selectedOptionPartner={selectedOptionPartner}
               handleChangePartner={handleChangePartner}
               description={description}
               setDescription={setDescription}
               loadOptionsFactories={loadOptionsFactory}
               selectedOptionFactories={selectedOptionFactories}
               handleChangeFactories={handleChangeFactories}
               urlRouter={urlApi}
               agreementsOptions={agreementsOptions}
               selectedAgreement={selectedAgreement}
               setSelectedAgreement={setSelectedAgreement}
               handleChangeAgreement={handleChangeAgreement}
               handleFileChange={handleFileChange}
               graficLoad={graficLoad}
               engineers={engineers}
               handleChangeEngineers={handleChangeEngineers}
               fileInputRef={fileInputRef}
            />)}
      </div>
   )
}
